import React, { useState, useEffect, useCallback } from 'react';
import {
  Table, Button, Space, Card, Typography, message, Row, Col, Input, Tag,
} from 'antd';
import { FileDoneOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import api from '../../api/axios';

const { Title } = Typography;
const { Search } = Input;

const SatisSozlesmeListe = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/satilik');
      const arr = Array.isArray(res.data) ? res.data : res.data.data || [];
      setData(arr);
    } catch {
      message.error('Satılık kayıtlar yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const filtered = data.filter((item) => {
    const q = searchText.toLowerCase();
    return (
      (item.saticiAdi || '').toLowerCase().includes(q) ||
      (item.aliciAdi || '').toLowerCase().includes(q) ||
      (item.ilAdi || '').toLowerCase().includes(q)
    );
  });

  const formatMoney = (val) => {
    if (!val && val !== 0) return '-';
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(val);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: 'Satıcı',
      dataIndex: 'saticiAdi',
      key: 'saticiAdi',
      render: (t) => <strong>{t || '-'}</strong>,
    },
    {
      title: 'Alıcı',
      dataIndex: 'aliciAdi',
      key: 'aliciAdi',
    },
    {
      title: 'İl / İlçe',
      key: 'adres',
      render: (_, r) => `${r.ilAdi || '-'} / ${r.ilceAdi || '-'}`,
    },
    {
      title: 'Ana Para',
      dataIndex: 'anapara',
      key: 'anapara',
      render: (v) => <span className="money-value">{formatMoney(v)}</span>,
    },
    {
      title: 'Oluşturan',
      dataIndex: 'kayitKullanici',
      key: 'kayitKullanici',
      render: (v) => v || '-',
    },
    {
      title: 'İşlem',
      key: 'action',
      fixed: 'right',
      width: 180,
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          icon={<FileDoneOutlined />}
          onClick={() => navigate(`/satis-sozlesmesi/${record.id}`)}
        >
          Sözleşme Oluştur / Görüntüle
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Space>
            <FileDoneOutlined style={{ fontSize: 20, color: '#1677ff' }} />
            <Title level={4} style={{ margin: 0 }}>Satış Sözleşmeleri</Title>
          </Space>
        </Col>
        <Col>
          <Search
            placeholder="Ara..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
            style={{ width: 220 }}
          />
        </Col>
      </Row>

      <Card className="content-card" bodyStyle={{ padding: 0 }}>
        <Table
          columns={columns}
          dataSource={filtered}
          rowKey="id"
          loading={loading}
          bordered
          size="middle"
          scroll={{ x: 800 }}
          pagination={{ pageSize: 15, showTotal: (t) => `Toplam ${t} kayıt` }}
          locale={{ emptyText: 'Satılık kayıt bulunamadı' }}
        />
      </Card>
    </div>
  );
};

export default SatisSozlesmeListe;
